import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import styles from './index.scss';

class SeInput extends Component {
    constructor(props) {
        super(props);
        /**
         * @typedef {('initial' | 'changed' | 'focused')} Step
         * @type {{step: Step, defaultValue: string}}
         */
        this.state = {
            defaultValue: props.defaultValue === undefined ? props.value : props.defaultValue,
            step: 'initial',
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (
            SeInput.isDefaultValue(nextProps.value, [prevState.defaultValue, ...nextProps.defaultValues]) ||
            SeInput.isEmpty(nextProps.value)
        ) {
            return null;
        }
        return {
            step: 'changed',
        };
    }

    static isDefaultValue(value, defaultValues) {
        return defaultValues.some(v => v === value);
    }

    static isEmpty(value) {
        return value === '';
    }

    handleFocus = ev => {
        this.setState(({ step }) => {
            if (step === 'initial') {
                return { step: 'focused' };
            }
            return null;
        });

        this.props.onFocus(ev);
    };

    handleBlur = ev => {
        const { value } = ev.target;

        this.setState(({ step }) => {
            if (step === 'focused') {
                return { step: 'initial' };
            }
            return null;
        });

        if (value === '') {
            this.props.onChange(this.state.defaultValue);
        }

        this.props.onBlur();
    };

    handleChange = ev => {
        const { value } = ev.target;

        const isEmptyString = value === '';

        this.setState(() => {
            const destinationStep = isEmptyString ? 'initial' : 'changed';
            return { step: destinationStep };
        });

        this.props.onChange(value);
    };

    render() {
        const {
            intl: { formatMessage },
            placeholderId,
            placeholder,
            extraClass,
            onFocus,
            onChange,
            onBlur,
            value,
            block,
            autoSetDefaults,
            defaultValues,
            defaultValue,
            ...otherProps
        } = this.props;

        let placeholderValue = placeholder;

        if (placeholderId) {
            placeholderValue = formatMessage({ id: placeholderId });
        }

        const shouldShowValue = this.state.step !== 'focused' || !autoSetDefaults;

        const inputClass = classNames({
            [styles.seInput]: true,
            [styles.block]: block,
            [extraClass]: !!extraClass,
        });
        return (
            <input
                type="text"
                className={inputClass}
                placeholder={placeholderValue}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                value={shouldShowValue ? this.props.value : ''}
                {...otherProps}
            />
        );
    }
}

SeInput.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultValues: PropTypes.array,
    placeholder: PropTypes.string,
    placeholderId: PropTypes.string,
    extraClass: PropTypes.string,
    block: PropTypes.bool,

    autoSetDefaults: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
};

SeInput.defaultProps = {
    placeholder: '',
    placeholderId: '',
    extraClass: '',
    autoSetDefaults: true,
    defaultValues: [],
    block: false,
    onFocus: () => {},
    onBlur: () => {},
    onChange: () => {},
};

export default injectIntl(SeInput);
